import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IContractState } from './contract.types';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IContractState = {
  contracts: [],
  count: 0,
  version: 1,
  lastPromise: null
};

const namespaced = true;

export const contract: Module<IContractState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
